import React from 'react';
import { Container, Nav, Navbar, NavDropdown, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faCircleUser } from '@fortawesome/free-regular-svg-icons';
import { getCartCount, isLoggedIn } from '../Session/Session'

class TopNavBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userName: "",
            languages: ['LT', 'EN', 'RU'],
            activeLanguage: 'LT',
            activeRoute: 0,
            cartCount: 0,
            loginLink: "/Login",
        };

        this.updateCartCount = this.updateCartCount.bind(this);
        this.accountIconHandler = this.accountIconHandler.bind(this);
        this.renderTooltip = this.renderTooltip.bind(this);
    }

    componentDidMount() {
        this.setState({ activeRoute: this.props.activeRoute });
        this.setState({ cartCount: getCartCount() });
        if (isLoggedIn() !== "") {
            this.setState({ loginLink: "/Account" });
        }
    }

    componentDidUpdate() {

    }

    updateCartCount = () => {
        this.setState({ cartCount: getCartCount() });
    }

    accountIconHandler = (event) => {
        event.preventDefault();
        if (isLoggedIn() === "") {
            window.location.href = this.state.loginLink;
        }
        else {
            window.location.href = "/Account";
        }
    }

    renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {isLoggedIn() === "" ? "Prisijungti" : "Mano paskyra"}
        </Tooltip>
    );

    render() {



        return (
            <Container>
                <Navbar variant="dark" expand="lg" sticky="top">
                    <Navbar.Brand href="/">
                        <img src='/logo.png' width="75" height="75" className="d-inline-block align-top" alt="Logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll">
                        <Nav>
                            <Nav.Link href="/renginiai" active={this.state.activeRoute === 1}>Renginiai</Nav.Link>
                            <Nav.Link href="/kursai" active={this.state.activeRoute === 2}>Kursai</Nav.Link>
                            <Nav.Link href="/renginiai-vaikams" active={this.state.activeRoute === 3}>Renginiai vaikams</Nav.Link>
                            <Nav.Link href="/apie" active={this.state.activeRoute === 6}>Apie</Nav.Link>
                            <Nav.Link href="/esprojektas" active={this.state.activeRoute === 7}>ES Projektas</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                    <Navbar.Collapse className="justify-content-end">
                        <Form className="d-flex">
                            <Form.Control
                                type="search"
                                placeholder="ieškoti renginio..."
                                className="me-2"
                                aria-label="Search"
                            />
                            <Button variant="outline-light"><FontAwesomeIcon icon={faMagnifyingGlass}></FontAwesomeIcon></Button>
                        </Form>
                        <NavDropdown title={this.state.activeLanguage} id="basic-nav-dropdown" className='nav-lang-selector'>
                            <NavDropdown.Item href="/" className='nav-lang-item'>LT</NavDropdown.Item>
                            <NavDropdown.Item href="/" className='nav-lang-item'>EN</NavDropdown.Item>
                            <NavDropdown.Item href="/" className='nav-lang-item'>RU</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link onClick={this.accountIconHandler} className='nav-item-icon' active={this.state.activeRoute === 9}>
                            <OverlayTrigger
                                      placement="bottom"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={this.renderTooltip}>
                                <FontAwesomeIcon className='nav-icon' icon={faCircleUser} />
                            </OverlayTrigger>
                        </Nav.Link>
                        <Nav.Link href="/cart" className='nav-item-icon' active={this.state.activeRoute === 8}>
                            <div>
                                <FontAwesomeIcon className='nav-icon' icon={faCartShopping} />
                                <span className="cart-icon-count">{this.state.cartCount}</span>
                            </div>
                        </Nav.Link>
                    </Navbar.Collapse>
                </Navbar>
            </Container>
        )
    }
}

export default TopNavBar;
